import React from "react"
import MetaTags from "react-meta-tags"
import { useLocation, useHistory } from "react-router-dom"
import { Container, Badge, Button } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"

const statusColor = status => {
  switch (status) {
    case "PAID":
      return "success"
    case "REJECTED":
      return "danger"
    case "PENDING":
      return "warning"
    default:
      return "secondary"
  }
}

const WithdrawalDetail = () => {
  const location = useLocation()
  const history = useHistory()
  const item = location.state?.item

  if (!item) {
    return (
      <div className="page-content">
        <Container fluid>
          <p className="text-center mt-5 text-muted">
            No withdrawal data found.
          </p>
          <div className="text-center">
            <Button color="primary" onClick={() => history.push("/payments")}>
              Back to Payments
            </Button>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Withdrawal Detail | Qlearn</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Payment" breadcrumbItem="Withdrawal Detail" />

          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-sm-12">
              <div className="card shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center bg-white">
                  <h5 className="mb-0 fw-bold">Withdrawal Details</h5>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => history.goBack()}
                  >
                    ← Back
                  </Button>
                </div>

                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Transaction ID</p>
                        <p className="fw-semibold mb-0 text-break">
                          {item._id}
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Status</p>
                        <Badge
                          color={statusColor(item.status)}
                          className="fs-6 px-3 py-1"
                          style={{ color: "black" }}
                        >
                          {item.status}
                        </Badge>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Payment Method</p>
                        <p className="fw-semibold mb-0">{item.paymentMethod}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Applied Amount</p>
                        <p className="fw-semibold mb-0 fs-5">
                          ৳ {item.amount || 0}
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Received Amount</p>
                        <p className="fw-semibold mb-0 fs-5">
                          ৳ {item.paidAmount || 0}
                        </p>
                      </div>
                    </div>{" "}
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Apply Date</p>
                        <p className="fw-semibold mb-0">
                          {item.applyDate || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="p-3 bg-light rounded">
                        <p className="text-muted mb-1 small">Received Date</p>
                        <p className="fw-semibold mb-0">
                          {item.recievedDate || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {item.recievedImage && (
                    <div className="mt-4">
                      <p className="fw-semibold mb-2">Payment Receipt</p>
                      <div
                        className="border rounded overflow-hidden"
                        style={{ maxWidth: "400px" }}
                      >
                        <img
                          src={item.recievedImage}
                          alt="Payment Receipt"
                          className="img-fluid w-100"
                          style={{ objectFit: "contain", maxHeight: "350px" }}
                          onError={e => {
                            e.target.style.display = "none"
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default WithdrawalDetail
